export default __webpack_public_path__ + "static/media/uy.3b3241a9.svg";